import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { ResetDeviceRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { ResetDeviceResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const resetDevice = (request: ResetDeviceRequest, options?: CashRequestOptions) =>
  post<ResetDeviceRequest, ResetDeviceResponse>('/2.0/cash/reset-device', request, { ...options, rejectOnError: true })
